import React from 'react';

const spinnerCSS = `
.wrapper{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  z-index: 9999; 
}
.gears{
  width:48%;
  display: inline-block;
}
.gears:first-child{
  margin-right: 3%;
}
.gears-container{
    width:150px; 
    height: 150px;
    font-size:24px;
    padding: 9%;
    position: relative; 
    margin: 0px auto;
}
.gear-rotate{
	width: 48px;
	height: 48px;
  top: 40%; 
  left: 45%; 
  margin-top: 10px;
  margin-left: 32px;
	background: #008BCF;
	position: absolute;
	border-radius: 1em;
	-webkit-animation: 1s gear-rotate linear infinite;
	-moz-animation: 1s gear-rotate linear infinite;
	animation: 1s gear-rotate linear infinite;
}
.gear-rotate-left{
  margin-top: -20px;
  margin-left: -20px;
  top: 40%;
  left: 45%; 
  width: 48px;
	height: 48px;
	background: #008BCF;
	position: absolute;
	border-radius: 1em;
  -webkit-animation: 1s gear-rotate-left linear infinite;
  -moz-animation: 1s gear-rotate-left linear infinite;
  animation: 1s gear-rotate-left linear infinite;
}

.gear-rotate::before, .gear-rotate-left::before {
	width: 2.8em;
	height: 2.8em;
	background: 
    -webkit-linear-gradient(0deg,transparent 39%,#008BCF 39%,#008BCF 61%, transparent 61%),
    -webkit-linear-gradient(60deg,transparent 42%,#008BCF 42%,#008BCF 58%, transparent 58%),
    -webkit-linear-gradient(120deg,transparent 42%,#008BCF 42%,#008BCF 58%, transparent 58%);
	background: 
    -moz-linear-gradient(0deg,transparent 39%,#008BCF 39%,#47EC19 61%, transparent 61%),
    -moz-linear-gradient(60deg,transparent 42%,#008BCF 42%,#008BCF 58%, transparent 58%),
    -moz-linear-gradient(120deg,transparent 42%,#008BCF 42%,#008BCF 58%, transparent 58%);
	background: 
    -o-linear-gradient(0deg,transparent 39%,#008BCF 39%,#008BCF 61%, transparent 61%),
    -o-linear-gradient(60deg,transparent 42%,#008BCF 42%,#008BCF 58%, transparent 58%),
    -o-linear-gradient(120deg,transparent 42%,#47EC19 42%,#008BCF 58%, transparent 58%);
	background: -ms-linear-gradient(0deg,transparent 39%,#008BCF 39%,#008BCF 61%, transparent 61%),-ms-linear-gradient(60deg,transparent 42%,#008BCF 42%,#008BCF 58%, transparent 58%),-ms-linear-gradient(120deg,transparent 42%,#008BCF 42%,#008BCF 58%, transparent 58%);
	background: 
      linear-gradient(0deg,transparent 39%,#008BCF 39%,#008BCF 61%, transparent 61%),
    linear-gradient(60deg,transparent 42%,#008BCF 42%,#008BCF 58%, transparent 58%),
    linear-gradient(120deg,transparent 42%,#008BCF 42%,#008BCF 58%, transparent 58%);
	position: absolute;
	content:"";
	top: -.4em;
	left: -.4em;
	border-radius:1.4em;
}
.gear-rotate::after, .gear-rotate-left::after {
	width: 1em;
	height: 1em;
	background: #fff;
	position: absolute;
	content:"";
	top: .5em;
	left: .5em;
	border-radius: .5em;
}

/*
 * Keyframe Animations 
 */ 

@-webkit-keyframes gear-rotate {
  0% { 
    -webkit-transform: rotate(0deg);
  }
  100% { 
    -webkit-transform: rotate(-180deg); 
  }
}

@-moz-keyframes gear-rotate {
  0% { 
    transform: rotate(0deg);
  }
  100% { 
    transform: rotate(-180deg); 
  }
}

@keyframes gear-rotate {
  0% { 
    transform: rotate(0deg); 
  }
  100% { 
    transform: rotate(-180deg); 
  }
}

@-webkit-keyframes gear-rotate-left {
 0% {
   -webkit-transform: rotate(30deg); 
  }
  100% {
    -webkit-transform: rotate(210deg);
  }
}

@-moz-keyframes gear-rotate-left {
 0% { 
   -webkit-transform: rotate(30deg); 
  }
  100% { 
    -webkit-transform: rotate(210deg);
  }
}

@keyframes gear-rotate-left {
 0% { 
   -webkit-transform: rotate(30deg); 
  }
  100% { 
    -webkit-transform: rotate(210deg);
  }
}
`;

const Spinner = () => {
    return (
        <>
            <style>{spinnerCSS}</style>
            <div class="wrapper">
              <div class="gears" id="two-gears">
                <div class="gears-container">
                  <div class="gear-rotate"/>
                  <div class="gear-rotate-left"/>
                </div>
              </div>
            </div>
        </>
    );
};

export default Spinner;